import React, { useState, useEffect, useContext } from "react";
import Form from "../../../components/form";
import ijws from "../../../services/ijws";
import AppContext from "../../../container/context";
import { formatDateTime } from "../../../helpers/helpers";
import modalidadeAssinatura from "../../../enums/modalidadeAssinatura";
import ActionTable from "../../../components/table/ActionTable";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

const Usuario = (props) => {
  const { notification, confirm } = useContext(AppContext);
  const [usuarioId] = useState(Number(props.match.params.id));
  const [usuario, setUsuario] = useState({});
  const [dadosEndereco, setDadosEndereco] = useState({});
  const [dadosPerfil, setDadosPerfil] = useState({});
  const [dadosAssinatura, setDadosAssinatura] = useState({});
  const [alterandoSenha, setAlterandoSenha] = useState(false);
  const [confirmacaoAssinatura, setConfirmacaoAssinatura] = useState(false);
  const [compras, setCompras] = useState([]);
  const [niveis, setNiveis] = useState([]);
  const [criandoAssinatura, setCriandoAssinatura] = useState(false);
  const [compraSelecionada, setCompraSelecionada] = useState({});
  const [encerrando, setEncerrando] = useState(false);
  const [valorEncerrar, setValorEncerrar] = useState("suspender");
  const [reembolsar, setReembolsar] = useState(false);
  const [dadosCancelamento, setDadosCancelamento] = useState({});

  useEffect(() => {
    if (usuarioId > 0) {
      carregarUsuario();
      listarCompras();
    }
    listarNiveis();
  }, [usuarioId]);

  const carregarUsuario = () => {
    ijws
      .get("admin/usuarios/carregar", { id: usuarioId })
      .then((usuario) => {
        if (usuario.assinatura.criacao) {
          if (usuario.assinatura.modalidadePagamento === 1)
            usuario.assinatura.modalidadeNome = "Boleto bancário";
          if (usuario.assinatura.modalidadePagamento === 2)
            usuario.assinatura.modalidadeNome = "Cartão de crédito";
          if (usuario.assinatura.modalidadePagamento === 3)
            usuario.assinatura.modalidadeNome = "Pix";

          if (usuario.assinatura.modalidade === 2) setValorEncerrar("cancelar");
          // if (usuario.assinatura.modalidade === 2) setValorEncerrar("cancelar");
        }

        setDadosAssinatura(usuario.assinatura);
        setDadosPerfil(usuario.perfil);
        setDadosEndereco(usuario.endereco);
        setUsuario(usuario);
        setConfirmacaoAssinatura(false);
      })
      .catch((err) => notification("error", '"Erro ao carregar o usuário'));
  };

  const listarCompras = () => {
    ijws
      .get("admin/usuarios/listarCompras", { usuarioId })
      .then((res) => {
        res.forEach((c) => {
          c.operacao = formatDateTime(c.operacao, "D/M/Y h:m");

          if (c.valorCentavos) {
            c.valor = (c.valorCentavos / 100).toFixed(2);
          }
          if (c.modalidadePagamento === 1) {
            c.modalidade = "Boleto bancário";
          }
          if (c.modalidadePagamento === 2) {
            c.modalidade = "Cartão de crédito";
          }
          if (c.modalidadePagamento === 3) {
            c.modalidade = "Pix";
          }
          if (c.pagamento)
            return (c.situacao = `Pagamento confirmado (${formatDateTime(
              c.pagamento,
              "D/M/Y h:m"
            )})`);
          if (c.cancelamento) {
            c.situacao = `Cancelada (${formatDateTime(
              c.cancelamento,
              "D/M/Y h:m"
            )})`;
            return;
          }
          return (c.situacao = "Pendente");
        });
        setCompras(res);
      })
      .catch((e) => {
        console.log(e);
        notification(
          "error",
          '"Não foi possível listar as compras do usuário.'
        );
      });
  };

  const listarNiveis = () => {
    ijws
      .get("admin/niveis/listar")
      .then((niveis) => {
        setNiveis(niveis);
      })
      .catch((e) => {
        notification("error", "Não foi possível listar os níveis");
      });
  };

  const formulario = () => {
    return {
      nome: {
        label: "Nome completo",
        type: "text",
        value: usuario.nome,
        required: true,
        space: 12,
      },
      CPF: {
        label: "CPF (apenas números)",
        type: "number",
        value: usuario.CPF,
        space: 4,
      },
      email: {
        label: "Email",
        type: "text",
        value: usuario.email,
        required: true,
        space: 4,
      },
      telefone: {
        label: "Telefone",
        type: "text",
        value: usuario.telefone,
        space: 4,
      },
      dataAceiteTermo: {
        label: "Cadastro",
        type: "text",
        value: formatDateTime(usuario.dataAceiteTermo, "D/M/Y, h:m"),
        readOnly: true,
        space: 4,
      },
      ultimoAcessoApp: {
        label: "Último acesso app",
        type: "text",
        value: formatDateTime(usuario.ultimoAcessoApp, "D/M/Y, h:m"),
        readOnly: true,
        space: 4,
      },
      ativo: {
        label: "Ativo",
        type: "check",
        value: usuario.ativo ? true : false,
        space: 4,
        disabled: true,
      },

      // senha: {
      //   label: "Senha",
      //   type: "password",
      //   value: usuario.senha,
      //   required: usuarioId === 0,
      //   space: 6,
      //   visible: usuarioId === 0,
      // },
      // confirmacaoSenha: {
      //   label: "Confirmar senha",
      //   type: "password",
      //   value: usuario.confirmacaoSenha,
      //   required: usuarioId === 0,
      //   space: 6,
      //   visible: usuarioId === 0,
      // },
    };
  };

  const salvar = (formulario, permanecer = false) => {
    // const usuarioSalvar = formulario;
    if (usuario.id > 0) {
      const dadosEnviar = {
        id: usuario.id,
        nome: formulario.nome,
        CPF: formulario.CPF,
        email: formulario.email,
        telefone: formulario.telefone,
      };
      ijws
        .post("admin/usuarios/editar", dadosEnviar)
        .then((res) => {
          notification("success", "Dados salvos!");
          if (permanecer) {
            carregarUsuario();
          } else {
            props.history.goBack();
          }
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            case 2:
              return notification("error", "Email inválido");
            case 3:
              return notification("error", "CPF inválido");
            case 4:
              return notification("error", "Email já em uso");
            default:
              return notification("error", "Erro ao editar o usuário");
          }
        });
      // } else {
      //   if (usuarioSalvar.senha !== usuarioSalvar.confirmacaoSenha)
      //     return notification(
      //       "warning",
      //       "A confirmação não confere com a senha."
      //     );

      //   peij
      //     .post("usuarios/inserir", usuarioSalvar)
      //     .then((res) => {
      //       if (res.errCodes.length === 0) {
      //         notification("success", "Dados salvos!");

      //         return props.history.goBack();
      //       }
      //       notification(
      //         "error",
      //         "Erro ao salvar os dados. Verifique as informações"
      //       );
      //     })
      //     .catch((err) => notification("error", "Erro ao salvar o usuário"));
    }
  };

  const reativarCadastro = () => {
    confirm({
      title: "Deseja continuar?",
      label:
        "O usuário terá acesso reestabelecido à plataforma com o login utilizado anteriormente",
      onConfirm: () => {
        ijws
          .post("admin/usuarios/ativar", { usuarioId: usuario.id })
          .then((res) => {
            notification("success", "Cadastro reativado!");
            carregarUsuario();
          })
          .catch((err) => {
            notification(
              "error",
              "Não foi possível inativar cadastro. Tente novamente mais tarde."
            );
          });
      },
    });
  };

  const inativarCadastro = () => {
    confirm({
      title: "Deseja continuar?",
      label:
        "O usuário não conseguirá efetuar login e criar uma nova assinatura.",
      onConfirm: () => {
        ijws
          .post("admin/usuarios/inativar", { usuarioId: usuario.id })
          .then((res) => {
            notification("success", "Cadastro inativado!");
            carregarUsuario();
          })
          .catch((err) => {
            notification(
              "error",
              "Não foi possível inativar cadastro. Tente novamente mais tarde."
            );
          });
      },
    });
  };

  const fUsuario = {
    title: "Dados cadastrais",
    form: formulario(),
    history: props.history,
    close: {},
    submit: {
      action: salvar,
      label: "Salvar",
    },
    customActions: usuario.ativo
      ? [
          {
            label: "Salvar e continuar editando",
            action: (form) => salvar(form, true),
          },
          {
            label: "Alterar senha",
            action: () => setAlterandoSenha(true),
          },
          {
            warning: true,
            label: "Inativar cadastro",
            action: inativarCadastro,
          },
          // {
          //   label: "Gerar token de pagamento",
          //   action: () =>
          //     props.history.push(
          //       `/app/configuracoes/usuarios/${usuario.id}/token-pagamento`
          //     ),
          // },
        ]
      : [
          {
            label: "Salvar e continuar editando",
            action: (form) => salvar(form, true),
          },
          {
            label: "Alterar senha",
            action: () => setAlterandoSenha(true),
          },
          {
            warning: true,
            label: "Reativar cadastro",
            action: reativarCadastro,
          },
        ],
  };

  const endereco = () => {
    return {
      rua: {
        label: "Endereço Rua",
        type: "text",
        value: dadosEndereco.rua,
        space: 6,
      },
      numero: {
        label: "Endereço Número",
        type: "text",
        value: dadosEndereco.numero,
        space: 3,
      },
      complemento: {
        label: "Complemento",
        type: "text",
        value: dadosEndereco.complemento,
        space: 3,
      },
      CEP: {
        label: "CEP",
        type: "number",
        value: dadosEndereco.CEP,
        space: 3,
      },
      bairro: {
        label: "Bairro",
        type: "text",
        value: dadosEndereco.bairro,
        space: 3,
      },
      municipio: {
        label: "Município",
        type: "text",
        value: dadosEndereco.municipio,
        space: 4,
      },
      UF: {
        label: "UF",
        type: "select",
        emptyItem: true,
        space: 2,
        array: {
          data: estadosBrasileiros,
          value: "id",
          desc: "nome",
        },
        value: dadosEndereco.UF,
      },
    };
  };

  const salvarEndereco = (formEnviar) => {
    setDadosEndereco(formEnviar);

    const dadosEnviar = formEnviar;
    dadosEnviar.usuarioId = usuarioId;
    ijws
      .post("admin/usuarios/editarEndereco", dadosEnviar)
      .then((res) => {
        notification("success", "Endereço salvo!");
        carregarUsuario();
      })
      .catch((err) => {
        console.log("err", err);
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Nome inválido");
          case 2:
            return notification("error", "Email inválido");
          case 3:
            return notification("error", "CPF inválido");
          case 4:
            return notification("error", "Email já em uso");
          default:
            return notification("error", "Erro ao editar o usuário");
        }
      });
  };

  const fEndereco = {
    title: "Endereço",
    form: endereco(),
    submit: {
      action: salvarEndereco,
      label: "Salvar endereço",
    },
  };

  const salvarPerfil = (formEnviar) => {
    const dadosEnviar = formEnviar;

    dadosEnviar.id = dadosPerfil.id;

    ijws
      .post("admin/usuarios/perfis/editar", dadosEnviar)
      .then((res) => {
        notification("success", "Endereço salvo!");
        carregarUsuario();
      })
      .catch((err) => {
        console.log("err", err);
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Nome inválido");
          case 2:
            return notification("error", "Nível inválido");
          default:
            return notification("error", "Erro ao editar perfil");
        }
      });
  };

  const fPerfil = {
    title: "Perfil de acesso",
    form: {
      nome: {
        type: "text",
        label: "Nome",
        space: 6,
        value: dadosPerfil.nome,
      },
      nivelId: {
        label: "Nível",
        type: "select",
        emptyItem: true,
        space: 6,
        array: {
          data: niveis,
          value: "id",
          desc: "nome",
        },
        value: dadosPerfil.nivelId,
      },
    },
    submit: { label: "Salvar", action: salvarPerfil },
  };

  const camposAssinatura = () => {
    if (dadosAssinatura.identificador) {
      return {
        modalidade: {
          label: "Modalidade",
          type: "select",
          domain: modalidadeAssinatura,
          value: dadosAssinatura.modalidade,
          disabled: true,
          space: 4,
          emptyItem: true,
          emptyItemText: "(Selecione)",
        },
        criacao: {
          label: "Criação",
          type: "text",
          value: formatDateTime(dadosAssinatura.criacao, "D/M/Y, h:m"),
          readOnly: true,
          space: 4,
        },
        vencimento: {
          label: "Data de vencimento",
          type: "text",
          value: formatDateTime(dadosAssinatura.vencimento, "D/M/Y, h:m"),
          readOnly: true,
          space: 4,
        },
      };
    } else {
      return {
        componente: {
          type: "component",
          value: (
            <div style={{ textAlign: "center" }}>
              <h4>Usuário sem assinatura ativa.</h4>
            </div>
          ),
        },
      };
    }
  };

  const criarAssinaturaDireta = (form) => {
    if (!form.vencimento)
      return notification("warning", "Selecione uma data de vencimento");
    ijws
      .post("admin/assinaturas/inserirAvulsa", {
        usuarioId: usuario.id,
        vencimento: form.vencimento,
      })
      .then((res) => {
        notification("success", "Assinatura criada com sucesso!");
        setCriandoAssinatura(false);
        return carregarUsuario();
      })
      .catch((err) => {
        console.log("err", err);
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Vencimento inválido");
          case 2:
            return notification("error", "Usuário já com assinatura ativa");
          default:
            return notification("error", "Erro ao criar assinatura");
        }
      });
  };

  const alterarSenha = (form) => {
    if (form.senha !== form.confirmacaoSenha)
      return notification(
        "warning",
        "A senha informada é diferente da confirmação."
      );

    ijws
      .post("admin/usuarios/alterarSenha", {
        usuarioId: usuarioId,
        senha: form.senha,
      })
      .then((res) => {
        notification("success", "Senha alterada com sucesso");
        setAlterandoSenha(false);
      })
      .catch((err) => {
        console.log("err", err);
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Senha inválida");
          default:
            return notification("error", "Erro ao criar alterar senha");
        }
      });
  };

  const fAssinatura = {
    title: dadosAssinatura.identificador ? "Assinatura ativa" : "",
    form: camposAssinatura(usuario),
    submit: !dadosAssinatura.identificador
      ? { label: "Criar nova", action: () => setCriandoAssinatura(true) }
      : null,
    customActions: dadosAssinatura.identificador
      ? [
          {
            label: "Encerrar assinatura",
            action: () => setEncerrando(true),
          },
        ]
      : null,
  };

  const montarCampos = () => {
    const campos = {};

    campos.modalidade = {
      label: "Modalidade",
      type: "select",
      domain: modalidadeAssinatura,
      value: dadosAssinatura.modalidade,
      disabled: true,
      space: 4,
      emptyItem: true,
      emptyItemText: "(Selecione)",
    };
    campos.criacao = {
      label: "Criação",
      type: "text",
      value: formatDateTime(dadosAssinatura.criacao, "D/M/Y, h:m"),
      readOnly: true,
      space: 4,
    };
    campos.vencimento = {
      label: "Data de vencimento",
      type: "text",
      value: formatDateTime(dadosAssinatura.vencimento, "D/M/Y, h:m"),
      readOnly: true,
      space: 4,
    };
    campos.modalidadePagamento = {
      label: "Modalidade de pagamento",
      type: "text",
      value: dadosAssinatura.modalidadeNome,
      readOnly: true,
      space: 12,
    };
    campos.radio = {
      type: "component",
      value: (
        <FormControl>
          <FormLabel id="demo-radio-buttons-group-label">
            Tipo de encerramento
          </FormLabel>

          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue={valorEncerrar}
            name="radio-buttons-group"
            onChange={(e) => setValorEncerrar(e.target.value)}
          >
            {dadosAssinatura.modalidade === 1 && (
              <FormControlLabel
                value="suspender"
                control={<Radio />}
                label="Suspender assinatura (o usuário continua tendo acesso à plataforma até a data de vencimento)"
              />
            )}

            <FormControlLabel
              value="cancelar"
              control={<Radio />}
              label="Cancelar assinatura (o usuário imediatamente deixa de ter acesso à plataforma)"
            />
          </RadioGroup>
        </FormControl>
      ),
      space: 12,
    };

    if (
      valorEncerrar === "cancelar" &&
      dadosAssinatura.modalidadePagamento === 2
    ) {
      campos.reembolsar = {
        label: "Reembolsar compra",
        type: "check",
        space: 12,
        value: reembolsar,
      };
    }
    if (
      valorEncerrar === "cancelar" &&
      dadosAssinatura.modalidadePagamento === 1
    ) {
      campos.aviso = {
        // label: "Reembolsar compra",
        type: "component",
        space: 12,
        value: (
          <div style={{ textAlign: "center" }}>
            <h4>
              Modalidade de pagamento não reembolsável automaticamente. O
              reembolso deverá ocorrer em acerto direto com o cliente.
            </h4>
          </div>
        ),
      };
    }

    return campos;
  };

  const encerrarSuspender = (form) => {
    const dadosEnviar = {
      usuarioId: usuarioId,
      assinaturaIdentificador: dadosAssinatura.identificador,
    };

    if (form.reembolsar) {
      setReembolsar(form.reembolsar);
    }

    if (valorEncerrar === "cancelar") {
      dadosEnviar.reembolsar = form.reembolsar;

      confirm({
        title: "Confirma o cancelamento da assinatura?",
        label: "",
        onConfirm: () => {
          ijws
            .post("admin/assinaturas/cancelar", dadosEnviar)
            .then((res) => {
              setDadosCancelamento(res);
              notification("success", "Assinatura cancelada");
              setEncerrando(false);
              // return carregarUsuario();
            })
            .catch((err) => {
              console.log("err", err);

              const { data } = err;
              switch (data[0]) {
                case 1:
                  return notification(
                    "error",
                    "Assinatura com modalidade inválida para cancelamento"
                  );
                case 2:
                  return notification("error", "Assinatura já cancelada");
                case 3:
                  return notification(
                    "error",
                    "Assinatura com modalidade de pagamento não reembolsável"
                  );
                case 4:
                  return notification("error", "Assinatura não reembolsável");
                case 101:
                  return notification(
                    "error",
                    "Erro ao cancelar assinatura na Iugu"
                  );
                case 102:
                  return notification(
                    "error",
                    "Erro ao reembolsar fatura na Iugu"
                  );
                default:
                  return notification("error", "Erro ao cancelar assinatura");
              }
            });
        },
      });
    }
    if (valorEncerrar === "suspender") {
      confirm({
        title: "Confirma a suspensão da assinatura?",
        label: "",
        onConfirm: () => {
          ijws
            .post("admin/assinaturas/suspender", dadosEnviar)
            .then((res) => {
              notification("success", "Assinatura suspensa");
              setEncerrando(false);

              return carregarUsuario();
            })
            .catch((err) => {
              const { data } = err;
              switch (data[0]) {
                case 1:
                  return notification(
                    "error",
                    "Assinatura com modalidade inválida para suspensão"
                  );
                case 2:
                  return notification("error", "Assinatura já suspensa");
                case 3:
                  return notification("error", "Assinatura cancelada");
                case 101:
                  return notification(
                    "error",
                    "Erro ao suspender a assinatura na Iugu"
                  );

                default:
                  return notification("error", "Erro ao suspender assinatura");
              }
            });
        },
      });
    }
  };

  const fEncerrarAssinatura = {
    title: "Encerrar assinatura",
    form: montarCampos(),
    submit: {
      label: "Finalizar",
      action: encerrarSuspender,
    },
    close: {
      label: "fechar",
      action: () => setEncerrando(false),
    },
  };

  const fAssinaturaDireta = {
    title: "Assinatura direta",
    form: {
      vencimento: {
        label: "Vencimento",
        type: "date",
        // value: 1,
        space: 4,
      },
    },

    submit: { label: "Criar assinatura", action: criarAssinaturaDireta },
    close: {
      label: "voltar",
      action: () => setCriandoAssinatura(false),
    },
  };

  const fAlterarSenha = {
    title: "Alterar senha",
    form: {
      senha: {
        label: "Senha",
        type: "password",
        value: "",
        required: true,
        space: 6,
      },
      confirmacaoSenha: {
        label: "Confirmar senha",
        type: "password",
        value: "",
        required: true,
        space: 6,
      },
    },

    close: { label: "fechar", action: () => setAlterandoSenha(false) },

    submit: {
      label: "Alterar",
      action: alterarSenha,
    },
  };

  const tRegistros = {
    title: "Compras",
    onLineClick: (item) => setCompraSelecionada(item),

    columns: [
      {
        name: "descricao",
        label: "Descrição",
      },
      {
        name: "operacao",
        label: "Operação",
      },
      {
        name: "valor",
        label: "Valor (R$)",
      },
      {
        name: "modalidade",
        label: "Modalidade de pagamento",
      },
      {
        name: "situacao",
        label: "Situação",
      },
    ],
    array: compras,
  };

  const baixarArquivo = () => {
    window.open(compraSelecionada.faturaPDF);
  };

  const montarFormCompra = () => {
    const campos = {};

    campos.descricao = {
      label: "Descrição",
      type: "text",
      value: compraSelecionada.descricao,
      readOnly: true,
      space: 12,
    };

    campos.valor = {
      label: "Valor (R$)",
      type: "text",
      value: compraSelecionada.valor,
      readOnly: true,
      space: 4,
    };
    campos.modalidade = {
      label: "Modalidade de pagamento",
      type: "text",
      value: compraSelecionada.modalidade,
      readOnly: true,
      space: 4,
    };
    campos.operacao = {
      label: "Operação",
      type: "text",
      value: compraSelecionada.operacao,
      readOnly: true,
      space: 4,
    };
    campos.situacao = {
      label: "Situação",
      type: "text",
      value: compraSelecionada.situacao,
      readOnly: true,
      space: 4,
    };

    if (
      compraSelecionada.boletoLinhaDigitavel &&
      compraSelecionada.situacao === "Pendente"
    ) {
      campos.boletoLinhaDigitavel = {
        label: "Linha digitável do boleto",
        type: "text",
        value: compraSelecionada.boletoLinhaDigitavel,
        readOnly: true,
        space: 4,
      };
      campos.button = {
        type: "component",
        value: (
          <div
            style={{ display: "flex", alignItems: "center", height: "100%" }}
          >
            <Button
              style={{ color: "white" }}
              variant="contained"
              color="info"
              onClick={baixarArquivo}
            >
              baixar do boleto
            </Button>
          </div>
        ),
        space: 4,
      };
    }

    if (
      compraSelecionada.PIXCopiaCola &&
      compraSelecionada.situacao === "Pendente"
    ) {
      campos.PIXCopiaCola = {
        label: "Código copia e cola do PIX",
        type: "text",
        value: compraSelecionada.PIXCopiaCola,
        readOnly: true,
        space: 4,
      };
    }

    return campos;
  };

  const fCompra = {
    title: "Compra",
    form: montarFormCompra(),
    close: { label: "Voltar", action: () => setCompraSelecionada({}) },
  };

  //   - Identificador da assinatura (texto, space 6, apenas leitura)
  // - Identificador da fatura (texto, space 6, apenas leitura)
  // - Cancelada (chexkbox, space 6, apenas leitura)
  // - Reembolsada (checkbox, space 6, apenas leitura)
  // - (exibir caso "reembolsar" enviado como "true" porém não efetuado (validar a partir do campo "reembolsada")) componente com a legenda: "Reembolso não processado pela Iugu. Verificar situação da fatura diretamente no painel de controle da Iugu utilizando o identificador da fatura descrito acima."

  const montarFormCancelado = () => {
    const campos = {};

    campos.assinaturaIdentificador = {
      label: "Identificador da assinatura",
      type: "text",
      readOnly: true,
      space: 6,
      value: dadosCancelamento.assinaturaIdentificador,
    };
    campos.faturaIdentificador = {
      label: "Identificador da fatura",
      type: "text",
      readOnly: true,
      space: 6,
      value: dadosCancelamento.faturaIdentificador,
    };
    campos.cancelada = {
      label: "Assinatura cancelada",
      type: "check",
      disabled: true,
      space: 6,
      value: dadosCancelamento.cancelada,
    };

    campos.reembolsada = {
      label: "Reembolsada",
      type: "check",
      disabled: true,
      space: 6,
      value: dadosCancelamento.reembolsada,
    };

    if (!dadosCancelamento.reembolsada && reembolsar) {
      campos.legenda = {
        type: "component",
        space: 12,
        value: (
          <div>
            <h4>
              Reembolso não processado pela Iugu. Verificar situação da fatura
              diretamente no painel de controle da Iugu utilizando o
              identificador da fatura descrito acima.
            </h4>
          </div>
        ),
      };
    }

    return campos;
  };

  const fDadosCancelado = {
    title: "Assinatura cancelada",
    form: montarFormCancelado(),
  };

  return (
    <>
      {usuarioId === 0 ? (
        <Form formData={fUsuario} />
      ) : usuario.id ? (
        <>
          <Form formData={fUsuario} />
          <Form formData={fEndereco} />
          <Form formData={fPerfil} />
          {!dadosCancelamento.assinaturaIdentificador ? (
            <>
              {usuario.assinatura ? (
                <div>
                  {!criandoAssinatura && !encerrando && (
                    <Form formData={fAssinatura} />
                  )}
                  {criandoAssinatura && !encerrando && (
                    <Form formData={fAssinaturaDireta} />
                  )}
                  {encerrando && <Form formData={fEncerrarAssinatura} />}
                </div>
              ) : null}
            </>
          ) : (
            <Form formData={fDadosCancelado} />
          )}

          <Dialog
            open={alterandoSenha}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
          >
            <DialogContent>
              <Form formData={fAlterarSenha} />
            </DialogContent>
          </Dialog>

          {compras.length > 0 && !compraSelecionada.id ? (
            <ActionTable structure={tRegistros} />
          ) : null}

          {compraSelecionada.id && <Form formData={fCompra} />}
        </>
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

const estadosBrasileiros = [
  { nome: "Acre", id: "AC" },
  { nome: "Alagoas", id: "AL" },
  { nome: "Amapá", id: "AP" },
  { nome: "Amazonas", id: "AM" },
  { nome: "Bahia", id: "BA" },
  { nome: "Ceará", id: "CE" },
  { nome: "Distrito Federal", id: "DF" },
  { nome: "Espírito Santo", id: "ES" },
  { nome: "Goiás", id: "GO" },
  { nome: "Maranhão", id: "MA" },
  { nome: "Mato Grosso", id: "MT" },
  { nome: "Mato Grosso do Sul", id: "MS" },
  { nome: "Minas Gerais", id: "MG" },
  { nome: "Pará", id: "PA" },
  { nome: "Paraíba", id: "PB" },
  { nome: "Paraná", id: "PR" },
  { nome: "Pernambuco", id: "PE" },
  { nome: "Piauí", id: "PI" },
  { nome: "Rio de Janeiro", id: "RJ" },
  { nome: "Rio Grande do Norte", id: "RN" },
  { nome: "Rio Grande do Sul", id: "RS" },
  { nome: "Rondônia", id: "RO" },
  { nome: "Roraima", id: "RR" },
  { nome: "Santa Catarina", id: "SC" },
  { nome: "São Paulo", id: "SP" },
  { nome: "Sergipe", id: "SE" },
  { nome: "Tocantins", id: "TO" },
];

export default Usuario;
